var leica = leica || {};
leica.pi = leica.pi || {};
leica.pi.i18n = leica.pi.i18n || {};

window.translate = (function () { // TODO: namespace this function to either leica.pi.i18n or leica.pi.conferencing.i18n
  /**
   * Handles the translations in eSM. WV though, has it's own `translate` method.
   * @param key
   * @param options
   * @returns {string}
   */
  function translate (key, options) {
    if (i18next.isInitialized) {
      return i18next.t(key, options);
    } else {
      throw new Error('i18nService is not initialized.');
    }
  }

  /**
   * Generates a helper function that auto-prefixes all `translate` requests
   * usage:
   *     // Assume i18n contains: { some: { key: { prefix: { 'my-value': 'toasty' } } } }
   *     import {translate} from 'shared/services/I18nService';
   *     const $t = translate.scope('some.key.prefix');
   *     const someText = $t('my-value'); // -> 'toasty'
   */
  translate.scope = function (keyPrefix) {
    return function (key, options) {
      return translate(''.concat(keyPrefix, '.').concat(key), options);
    };
  };

  return translate;
}());

leica.pi.i18n.on = (function initI18Next () {
  var lang = SystemParms.Locale || 'en'; // language is in the Spectrum Config Array that can be read via SystemParms
  var config = {
    defaultLanguage: lang,
    fallbackLanguage: 'en',
    preLoad: [lang],
    // Really eSM should not know about conferencing/wv modules but it's so poorly designed we don't really have a way around it.
    languageModules: ['conference', 'webviewer'],
    defaultModules: ['conference', 'webviewer']
  };

  var initPromise = new Promise(function (resolve, reject) {
    i18next
      .use(i18nextXHRBackend)
      .init({
        lng: config.defaultLanguage,
        fallbackLng: config.fallbackLanguage,
        preload: config.preLoad,
        ns: config.languageModules,
        defaultNS: config.defaultModules,
        backend: {
          loadPath: '/dist/static/i18n/{{lng}}/{{ns}}.json'
        }
      }, function (error) {
        if (error) {
          reject(new Error('Error starting i18n service. ' + error));
        }
        resolve();
      });
  });

  // There appear to be issues with i18next's built-in "on" so let's create one that works.
  return function on (name, callback) {
    initPromise.then(callback);
  };
}());
